<h3 i18n="@@core.toc.opacity">Opacity</h3>
<div class="form-field form-field__slider">
  <tm-slider [min]="0"
             [max]="100"
             [step]="1"
             [value]="opacity$ | async"
             [displayWith]="formatThumb"
             [label]="label"
             (valueChange)="updateOpacity($event)">
  </tm-slider>
  <button mat-icon-button
          (click)="resetOpacity()"
          color="primary"
          [disabled]="(opacity$ | async) === 100"
          i18n-tmTooltip="@@core.toc.reset-opacity"
          tmTooltip="Reset opacity">
    <mat-icon svgIcon="reset"></mat-icon>
  </button>
</div>
